import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tf-core-fb-basic-input-checklist-single-select-type',
  templateUrl: './fb-basic-input-checklist-single-select-type.component.html',
  styleUrls: ['./fb-basic-input-checklist-single-select-type.component.css']
})
export class FbCoreBasicInputChecklistSingleSelectTypeComponent implements OnInit {
    @Input()
    data: any;

    constructor() { }

    ngOnInit(): void {
        if (this.data === undefined) {
            this.data = {
                type: 'single_select',
                options: [
                    {
                        label: "Option 1"
                    },
                    {
                        label: "Option 2"
                    }
                ]
            };
        }
    }

}
